import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const FormrCtx = createContext(null);
const FormrProvider = ({ context, renderers, builderOptions, children }) => {
    return (_jsx(FormrCtx.Provider, { value: { context, renderers, builderOptions }, children: children }));
};
export { FormrProvider };
//# sourceMappingURL=FormrProvider.js.map